const headerEl = document.getElementById('motimate-header');
const hamburger = document.getElementById('motimate-hamburger');
const mobileMenu = document.getElementById('mobile-navigation');
const desktopMenuItemsWithChildren = Array.prototype.slice.call(document.querySelectorAll('.motimate-header__desktop__nav .menu-item-has-children > a'));

class MobileMenu {
    constructor(hamburger, mobileMenuEl, headerEl) {
        this.hamburger = hamburger;
        this.headerEl = headerEl;
        this.mobileMenuEl = mobileMenuEl;
        this.htmlEl = document.querySelector('html')
        this.bodyEl = document.querySelector('body')

        this.focusTrap = focusTrap.createFocusTrap(headerEl);
    }

    isMobileMenuActive() {
        return this.mobileMenuEl.classList.contains('is-active');
    }

    toggleOverflow() {
        // Disable overflow globally, any Y overflow will be handled inside of the mobile menu.
        this.htmlEl.classList.toggle('overflow-hidden');
        this.bodyEl.classList.toggle('overflow-hidden');
    }

    toggleMobileMenu() {
        this.hamburger.classList.toggle('is-active');
        this.mobileMenuEl.classList.toggle('is-active');
        this.headerEl.classList.toggle('mobile-is-active');
        this.toggleOverflow();

        if (this.hamburger.getAttribute('aria-expanded') === 'false') {
            this.hamburger.setAttribute('aria-expanded', 'true')
        } else {
            this.hamburger.setAttribute('aria-expanded', 'false')
        }

        if (this.isMobileMenuActive()) {
            this.focusTrap.activate();
        } else {
            this.focusTrap.deactivate();
        }
    }

    setupHamburgerClickEvent() {
        if(this.hamburger) {
            this.hamburger.addEventListener('click', () => {
                this.toggleMobileMenu();
            })
        }
    }

    init() {
        this.setupHamburgerClickEvent()
    }
}

new MobileMenu(hamburger, mobileMenu, headerEl).init();

class DesktopMenu {
    constructor(headerEl, desktopMenuItemsWithChildren) {
        this.headerEl = headerEl;
        this.menuItems = desktopMenuItemsWithChildren
    }

    setupListeners() {
        this.menuItems.forEach((item) => {
            // Hover events
            item.addEventListener('mouseenter', (e) => {
                e.target.setAttribute('aria-expanded', 'true');
                e.target.parentNode.classList.add('focused');
                setTimeout(() => {
                    e.target.parentNode.classList.remove('focused');
                }, 500)
            })

            item.addEventListener('mouseleave', (e) => {
                e.target.setAttribute('aria-expanded', 'false');
            })

            // Focus Events
            item.addEventListener('focus', (e) => {
                e.target.setAttribute('aria-expanded', 'true');
                e.target.parentNode.classList.add('focused');
            });

            if (item.nextElementSibling) {
                const subMenu = item.nextElementSibling
                const subMenuLinks = subMenu.querySelectorAll('a')
                const lastLinkIndex = subMenuLinks.length - 1
                const lastLink = subMenuLinks[lastLinkIndex]

                lastLink.addEventListener('blur', () => {
                    item.parentNode.classList.remove('focused');
                    item.setAttribute('aria-expanded', false);
                })
            }
        })
    }

    init() {
        if(this.menuItems.length > 0) {
            this.setupListeners();
        }
    }
}

new DesktopMenu(headerEl, desktopMenuItemsWithChildren).init();
